/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Optica() {
  return (
    <PaginasEspecificas posicao="9" endereco="/fisica" materia="Física" />
  );
}

export default Optica;
